import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import RootState from "../../redux/states/root.state";
import Header from "../../components/common/Header/Header";
import SpaCommandsContainer from "./components/SpaCommandsContainer";
import { fetchSpaCommandsHistory } from "../../redux/actions/commands.actions";
import { toQuery } from "../../components/common/AutoRefresh/refreshParams";
import { TerminalLineIcon } from "../../components/common/Icons/Icons";

const SpaCommandsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.commands);

  // Derived so that toggling the auto-refresh interval (a client-only param) doesn't
  // count as a filter change and fire an extra fetch.
  const query = useMemo(() => toQuery(searchParams), [searchParams]);

  useEffect(() => {
    dispatch(fetchSpaCommandsHistory({ params: query }));
  }, [dispatch, query]);

  // Auto-refresh reuses whatever filters/sort/page are currently in the URL, and runs
  // silently so rows swap in without the table collapsing to a spinner.
  const handleRefresh = useCallback(() => {
    dispatch(fetchSpaCommandsHistory({ params: query, silent: true }));
  }, [dispatch, query]);

  return (
    <div className="page lp-page">
      <Header
        header="Spa Commands"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><TerminalLineIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Commands</li>
          </ul>
        }
      />
      <main className="lp-main">
        <SpaCommandsContainer onRefresh={handleRefresh}/>
      </main>
    </div>
  );
};

export default SpaCommandsPage;
